/* Per-user (per-browser) language override. Precedence: this override → the company-wide
   getAppConfig.language (the "global" language) → German. */
const STORAGE_KEY = 'userLanguage'
const VALID_LANGUAGES = ['German', 'English', 'French', 'Italian']

export const getUserLanguage = () => {
	const language = localStorage.getItem(STORAGE_KEY)
	return VALID_LANGUAGES.includes(language) ? language : null
}

export const setUserLanguage = language => {
	if (VALID_LANGUAGES.includes(language)) {
		localStorage.setItem(STORAGE_KEY, language)
	} else {
		/* anything else (empty option, junk) clears the override — back to the global language */
		localStorage.removeItem(STORAGE_KEY)
	}
}
